module.exports = __webpack_public_path__ + "img/desktop-contact.8e7b9b89.png";